import React from "react";
import { useNavigate } from "react-router-dom";
import sitemasterLogo from "../../assets/new logo.png";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../utils/constant";
import { toast } from "sonner";
import pana from "../../assets/dashboard/pana.svg";
import { FaArrowRight } from "react-icons/fa";

const WelcomePage = () => {
  const navigate = useNavigate();
  const [UserData, setUserData] = useState({});

  useEffect(() => {
    fetchUserData();
  }, []);

  async function fetchUserData() {
    try {
      const accessToken = localStorage.getItem("access");
      const res = await fetch(`${BASE_URL}/auth/user-details-of-user/`, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + accessToken,
        }),
        redirect: "follow",
      });
      if (!res?.ok) {
        navigate("/login");
      }
      const response = await res.json();
      if (!response.status) {
        if(response.message === "No user details found for this email"){
          navigate("/profession");
        }
        else{
          navigate("/login");
        }
      }
      setUserData(response.data);
    } catch (error) {
      toast.error(error.message);
    }
  }

  const handleGetStarted = () => {
    if(!UserData?.profession) {
      return;
    }
    
    // Set localStorage values
    localStorage.setItem("user", JSON.stringify(UserData));
    
    if (UserData?.profession === "owner") {
      localStorage.setItem("isOwner", "true");
      localStorage.setItem("isIndividual", "false");
      navigate("/");
    } else {
      localStorage.setItem("isOwner", "false");
      localStorage.setItem("isIndividual", "true");
      navigate("/dashboard");
    }
  };

  return (
    <div className="flex h-[100vh] bg-white">
      {/* Left half - SiteMaster logo */}
      <div className="w-[45%] h-full  flex items-center justify-center ">
        <img src={sitemasterLogo} alt="SiteMaster Logo" width={"80%"} />
      </div>

      {/* Right half - Content */}
      <div className="w-[55%] bg-white flex flex-col py-6 items-center px-24 justify-center">
        {/* Construction Workers Image */}
        <img src={pana} alt="Construction Workers" />

        {/* Welcome text and button */}
        <div className="p-4 flex flex-col justify-center">
          <h2 className="text-2xl font-semibold mb-4">
            Welcome, {UserData?.first_name}
          </h2>
          <p className="text-gray-600 mb-6">
            Your site is all set now, let's create your first site and manage
            your construction with the advanced features of SiteMaster...
          </p>
          <button
            onClick={handleGetStarted}
            style={{ alignSelf: "center" }}
            className="bg-btn-bg text-white font-bold text-lg px-6 py-3 rounded-lg w-72 flex items-center justify-center gap-3 hover:bg-purple-900 transition-colors"
          >
            Get Started
            <div className="p-1 rounded-full bg-[#58267F]">
              <FaArrowRight fill="white" />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;